<template lang="pug">
  v-dialog(
    id="HistoryDialog",
    v-model="isShowHistory",
    persistent,
    max-width="450")
    v-card(class="pa-2")
      v-card-title(class="py-0")
        v-layout(justify-space-between align-center)
          span(class="title") {{ historyModel.user }}
          v-btn(icon, @click.stop="closeHandler")
            v-icon close
      v-card-text(class="px-2 py-0")
        vue-form-generator(:schema="historyModel.schema" :model="historyModel.model")
      v-card-actions(class="pb-3")
        v-spacer
        v-btn(color="primary" large @click.stop="closeHandler") Закрыть
        v-spacer
</template>

<script>
export default {
  name: 'HistoryDialog',
  props: {
    isShowHistory: {
      type: Boolean,
      default: false
    },
    historyModel: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    closeHandler() {
      this.$emit('close-history-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/HistoryDialog.vue